// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"65dd21be","411":"6cd8c641","534":"7f9955b6","772":"26b108f1","954":"2d853297"}[chunkId] + ".chunk.css";
};